/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.standards.categories'},
});

const CategoriesItem = () => (
  <RouteLinkItem
    route="midas/settings/standards/categories"
    title={messages.title}
  />
);

export default CategoriesItem;
